import React, {ComponentType} from "react";
import {Meta, Story} from "@storybook/react";
import {ArgTypes} from "@storybook/addons/dist/ts3.9/types";
import {setLocale} from "yup";
import {LocaleFR} from "../locale/validation-locale";
import {LOGIN_MODE_EXPLICIT} from "../app-provider/apollo-client";
import {BaseAppProviderProps, ComponentWrapper} from "@betrue/common";

export const StoryBookWrapper = (
  COMPONENT: (any) => JSX.Element,
  AppProvider: (props: BaseAppProviderProps) => JSX.Element,
  args: any,
  parameters: any = {},
  argTypes: ArgTypes = {},
  loginMode?: string
): { bindTemplate: ComponentType, story: Meta } => {
  setLocale(LocaleFR)

  const Template: Story<any> = (args) => (
    <>
      <ComponentWrapper appProvider={AppProvider} loginMode={loginMode ? loginMode : LOGIN_MODE_EXPLICIT}>
        <COMPONENT {...args}/>
      </ComponentWrapper>
    </>);
  const bound = Template.bind({})
  bound.args = args
  bound.parameters = parameters
  return {
    bindTemplate: bound,
    story: {
      component: COMPONENT,
      title: COMPONENT.name,
      argTypes: argTypes
    } as Meta
  }
}
